<template>
<div class="chapter">
<div class="inner_page">
<p class="tx1" id="d7e24816"><br/><br/><br/><br/></p>
<p class="ser"><img alt="1" src="images/1.jpg" style="max-width:100%"/></p><p class="ct" id="d7e2816"><b>PART I <br/><i><big>Words You Absolutely <br/>Should Know </big></i></b></p>
<p class="ext" id="d7e2926">If you pride yourself as a good communicator, you absolutely must know the words in this section. If items on this list are unfamiliar to you, learn them immediately or risk being at an embarrassing loss for words!</p>
<p class="ser"><img alt="2" src="images/2.jpg" style="max-width:100%"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Haye_ISBN9781605501390_epub_c4_r1.vue?7b42a1d2